import { render } from "./GroupReservation.vue?vue&type=template&id=d707cab0&scoped=true"
import script from "./GroupReservation.vue?vue&type=script&lang=js"
export * from "./GroupReservation.vue?vue&type=script&lang=js"

import "./GroupReservation.vue?vue&type=style&index=0&id=d707cab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d707cab0"]])

export default __exports__